import { store } from '../store';

export default function checkPermission(permissionToCheck: string) {
  let hasPermission = false;

  const { user } = store.getState().auth;

  if (user && user.roles) {
    user.roles.forEach((role) => {
      if (role.permissions) {
        role.permissions.forEach((permission) => {
          if (permission.name === permissionToCheck) {
            hasPermission = true;
          }
        });
      }
    });
  }

  return hasPermission;
}
